import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { LclPortModel } from '@data-layer/models/lcl';

@Component({
  selector: 'app-lcl-create-quote-from-to-updated',
  templateUrl: './lcl-create-quote-from-to-updated.component.html',
  styleUrls: ['./lcl-create-quote-from-to-updated.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclCreateQuoteFromToUpdatedComponent {
  @Input() public departurePortFc: UntypedFormControl;
  @Input() public arrivalPortFc: UntypedFormControl;
  @Input() public isExternal: boolean;
  @Input() public isSubmitted: boolean;

  @Output() public onSelectFromPort: EventEmitter<LclPortModel> = new EventEmitter<LclPortModel>();
  @Output() public onSelectToPort: EventEmitter<LclPortModel> = new EventEmitter<LclPortModel>();
  @Output() public onSearch: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onClear: EventEmitter<void> = new EventEmitter<void>();
}
